import { Component, input } from '@angular/core';

import { DetailsValueComponent } from '@iw/common';

import { PayPal, WithdrawalReq } from '../../../entities';

@Component({
  selector: 'iw-paypal-details',
  imports: [DetailsValueComponent],
  templateUrl: './paypal-details.component.html',
  styleUrl: './paypal-details.component.scss',
})
export class PaypalDetailsComponent {
  withdrawalInfo = input.required<WithdrawalReq>();

  get details(): PayPal {
    return this.withdrawalInfo().details as PayPal;
  }
}
